import styled from 'styled-components';

export const LentilsWrapper = styled.div`
  padding-top: var(--size-dynamic0040);
  display: flex;
  align-items: center;
  flex-direction: column;
`;
